import { render } from "./AdminManualView.vue?vue&type=template&id=ec2ad440"
import script from "./AdminManualView.vue?vue&type=script&lang=js"
export * from "./AdminManualView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__